import { all, takeEvery } from 'redux-saga/effects';
import { ACTIONS } from '../types';
import { getGameRulesSaga } from './getGameRulesSaga';

export function* gameRulesSaga() {
  yield all([takeEvery(ACTIONS.GAME_RULES, getGameRulesSaga)]);
}
